<template>
    <div class="insert-rec insert-atlas">  
    <a :href="cardInfo.url" target="_blank" class="insert-box insert-atlas__box" :data-spm-data="cardInfo.spm">
        <div class="insert-atlas__gallery img-do">
            <div class="img-left">
                <img :src="cardInfo.images[0]" alt="">
            </div>
            <div class="img-right">
                <div class="img-right__item1">
                    <img :src="cardInfo.images[1]" alt="">
                </div>
                
                <div class="img-right__item2">
                    <img :src="cardInfo.images[2]" alt="">
                    <span class="img-right__cover"> {{cardInfo.images.length}}图</span>
                </div>
            </div>
        </div>

        <div class="insert-atlas__content">
            <p class="atlas-flag">
                <span><i class="atlas-icon"></i> 图集</span>
            </p>
            <h5 class="insert-rec__title insert-atlas__title">
                {{cardInfo.title}}
            </h5>
            <p class="auther"><span>作者：</span>{{cardInfo.author}}</p>
        </div>
    </a>
    <div style="clear: both"></div>
</div>
</template>

<script>

export default {
    props: {
        cardInfo: {
			type: Object,
			default: () => {
				return {};
			},
		},
    },
    data() {
        return {

        }
    },
    mounted() {
    },
    
}
</script>

<style lang="less" scoped>

</style>